import Component from '../component';

export default class VideoCard extends Component {
    constructor(...args) {
        super(...args);

    }

    init() {
        super.init();

        this.dom.popin = document.body.querySelector('.ct--popin-video');
        this.dom.video = this.dom.popin.querySelector('.video');

    }

	getIsBinded() {
		return (this.dom.component.classList.contains('is-binded')) ? true : false;
	}


    /*

    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/video-card/video-card.js